import uri from 'lil-uri';
import { log } from 'limuirs-utils';

/**
 * Builder for manipulating URLs, uses the {@code lil-uri} library
 * to parse and build URLs.
 *
 * @author Adam Ayres
 */
export default class UrlBuilder {
  static fromUrl(url) {
    return new UrlBuilder(url);
  }

  static fromGlobals({ tapestryPath = '' }) {
    return UrlBuilder.fromUrl(tapestryPath);
  }

  constructor(url) {
    this.url = uri(url);
  }

  /**
   * Add's key/value pairs to the path of a URL. Only accepts an even number of
   * arguments, otherwise will do nothing. Keys that already exists in the path
   * of the URL will be updates.
   *
   * @param keyValuePairs key value pairs to add to the path
   * @returns {UrlBuilder} this builder
   */
  addPath(...keyValuePairs) {
    const currentPathParts = this.url.path().split('/');
    if (keyValuePairs.length % 2 === 0) {
      for (let i = 0; i < keyValuePairs.length; i += 2) {
        const key = keyValuePairs[i];
        const value = keyValuePairs[i + 1];
        if (key && value) {
          const keyIndex = currentPathParts.indexOf(key);
          if (keyIndex > -1 && keyIndex + 1 < currentPathParts.length) {
            currentPathParts.splice(keyIndex + 1, 1, value);
          } else {
            currentPathParts.push(key);
            currentPathParts.push(value);
          }
        } else {
          log.warn(
            `UrlManager#addPath expects key value pairs to be valid values, found key: [${key}], value: [${value}]`
          );
        }
      }
    } else {
      log.warn('UrlManager#addPath expects key value pairs passed in for path parameters');
    }
    this.url.path(currentPathParts.join('/'));
    return this;
  }

  /**
   * Removes a key and it's associated value from a URL path. We treat path parameters
   * as key/values where the "key" path value precedes the "value" path value. If the key
   * does not exist then nothing will happen.
   *
   * @param key the key and it's associated value to remove from the URL
   * @returns {UrlBuilder} this builder
   */
  removePath(key) {
    const currentPathParts = this.url.path().split('/');
    const keyIndex = currentPathParts.indexOf(key);
    if (keyIndex > -1 && keyIndex + 1 < currentPathParts.length) {
      currentPathParts.splice(keyIndex, 2);
    } else {
      log.warn(`Did not find path param in URL to remove, key: [${key}]`);
    }
    this.url.path(currentPathParts.join('/'));
    return this;
  }

  build() {
    return this.url.build();
  }
}
